import { OrderEntity } from './OrderEntity.model';

export class OrderHistoryResponse {
  orderList?: OrderEntity[];
}
